import { getConfigEnv } from '@/modules/common/helpers/getConfigEnv';

export const DEVTOOLS_OPTIONS = {
  enabled: getConfigEnv() === 'development',
  name: 'DT',
  trace: true,
};
